/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { ApplicationInfoService } from './ApplicationInfoService';

class ApplicationInfoServiceProvider {
    /** @ngInject */
    constructor() {
        this.url = null;
    }

    setUrl(url) {
        this.url = url;
    }

    /** @ngInject */
    $get($http, $log) {
        return new ApplicationInfoService($http, $log, this.url);
    }
}

export { ApplicationInfoServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/service/ApplicationInfoServiceProvider.js